import { Link, useNavigate } from "react-router-dom"

const Pagination = ({ page, busqueda, pagActual, pagAPI, totalPaginas, filtroValue }) => {

    filtroValue = (filtroValue) ? filtroValue : ""

    let siguiente = parseInt(pagActual) + 1;
    let anterior = parseInt(pagActual) - 1;
    let isLoading = (pagActual != pagAPI) ? true : false
    const cantidadPaginas = 5
    const items = []
    let history = useNavigate()

    const calcularPaginas = () => {
        let inicio = 1
        let final = 1
        if (totalPaginas <= cantidadPaginas) {
            final = totalPaginas
        } else {
            inicio = 1 + cantidadPaginas * Math.floor((pagActual - 1) / cantidadPaginas)
            let finalAux = inicio + (cantidadPaginas - 1)
            if (finalAux < totalPaginas) {
                final = finalAux
            }
            else {
                final = totalPaginas
            }
        }
        for (inicio; inicio <= final; inicio++) {
            items.push(inicio)
        }
    }

    calcularPaginas();

    const handleNext = () => {
        if (pagActual < totalPaginas) {
            isLoading = true
            history(`/${page}?bus=${busqueda}&pag=${siguiente}&fil=${filtroValue}`)
        }
    }
    const handlePrev = () => {
        if (pagActual > 1) {
            isLoading = true
            history(`/${page}?bus=${busqueda}&pag=${anterior}&fil=${filtroValue}`)
        }
    }
    const handleGoPage = (pagina) => {
        isLoading = true
        history(`/${page}?bus=${busqueda}&pag=${pagina}&fil=${filtroValue}`)
    }

    return (
        <ul className="pagination float-right p-0 m-0">
            <li className="page-item">
                <button className="page-link" onClick={handlePrev} disabled={isLoading}><i className="fas fa-angle-double-left"></i></button>
            </li>
            {
                items.map((index) => {
                    return (
                        <li className={`page-item ${(pagAPI == index) && "active"}`} key={index}>
                            <button className="page-link" href="#" disabled={isLoading} onClick={() => handleGoPage(index)}>{index}</button>
                        </li>
                    )
                })
            }
            <li className="page-item">
                <button className="page-link" onClick={handleNext} disabled={isLoading}><i className="fas fa-angle-double-right"></i></button>
            </li>
        </ul>
    )

}
export default Pagination